/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hplc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is a geometric starting point. Differences in system dwell volume and extra-column effects mean you should verify critical separations experimentally.`)
};

const es_hplc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es un punto de partida geométrico. Las diferencias en el volumen muerto del sistema y los efectos extracolumna implican que debes verificar experimentalmente las separaciones críticas.`)
};

const de_hplc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er ist ein geometrischer Ausgangspunkt. Unterschiede im Totvolumen des Systems und extrakolumnäre Effekte bedeuten, dass Sie kritische Trennungen experimentell überprüfen sollten.`)
};

const nl_hplc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het is een geometrisch uitgangspunt. Verschillen in systeem-dwellvolume en extrakolomeffecten betekenen dat u kritieke scheidingen experimenteel moet verifiëren.`)
};

const fr_hplc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est un point de départ géométrique. Les différences de volume mort du système et les effets extra-colonnes signifient que vous devez vérifier expérimentalement les séparations critiques.`)
};

const it_hplc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È un punto di partenza geometrico. Differenze nel volume di ritardo del sistema ed effetti extra-colonna richiedono di verificare sperimentalmente le separazioni critiche.`)
};

const pt_br2_hplc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É um ponto de partida geométrico. Diferenças no volume morto do sistema e efeitos extracoluna significam que você deve verificar separações críticas experimentalmente.`)
};

const pt_hplc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É um ponto de partida geométrico. Diferenças no volume morto do sistema e efeitos extra-coluna significam que deve verificar experimentalmente as separações críticas.`)
};

const ja_hplc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`幾何学的な出発点にすぎません。システムのデッドボリュームやカラム外効果の違いがあるため、重要な分離は実験的に確認する必要があります。`)
};

const zh_hplc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这只是一个几何起点。由于系统滞留体积和柱外效应的差异，你应通过实验验证关键分离效果。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hplc_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hplc_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hplc_faq_a4", locale)
	if (locale === "en") return en_hplc_faq_a4(inputs)
	if (locale === "es") return es_hplc_faq_a4(inputs)
	if (locale === "de") return de_hplc_faq_a4(inputs)
	if (locale === "nl") return nl_hplc_faq_a4(inputs)
	if (locale === "fr") return fr_hplc_faq_a4(inputs)
	if (locale === "it") return it_hplc_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_hplc_faq_a4(inputs)
	if (locale === "pt") return pt_hplc_faq_a4(inputs)
	if (locale === "ja") return ja_hplc_faq_a4(inputs)
	return zh_hplc_faq_a4(inputs)
};